import {OfferResponseEvent} from '../../Shared/events';
import {sendAppEvent} from '../../tracking/app-events';

export const offerResponseAppEventListener = () => {
  document.addEventListener(OfferResponseEvent.eventType,
      (offerResponseEvent) => {
    sendAppEvent(OfferResponseEvent.eventType,
        {response: offerResponseEvent.response});
  });
};